module.exports = __webpack_public_path__ + "static/media/Cafe.73ac2932.webp";